import { motion } from "framer-motion";
import logo2 from "../../Assets/logo/footerLogo2025.webp";
import logo from "../../Assets/logo.webp";
import "./AnimatedLogo.css";

const AnimatedLogo = () => {
  return (
    <div className="brandLogo">
      <div className="imgcontainer">
        <img src={logo} height={52} width={52} className="logo" alt="logo"/>
        <div className="stripe"/>
      </div>
      {/* <div className="imgcontainer">
        <img src={logo2} height={52} width={52} className="logo" alt="logo"/>
        <div className="stripe"/>
      </div> */}
    </div>
  );
};
export default AnimatedLogo;
